<script setup lang="ts">
const props = defineProps<{
	googleLoading: boolean
}>()

const emit = defineEmits<{
	googleLogin: [void]
	phoneForm: [value: boolean]
}>()

function onPhoneNumber() {
	emit("phoneForm", true)
}

function onGoogleLogin() {
	if (props.googleLoading)
		return
	emit("googleLogin")
}
</script>

<template>
	<LoginContainer>
		<div class="flex flex-col items-center justify-center gap-y-4">
			<div class="text-xl md:text-2xl">
				به اپلیکیشن
				<span class="text-[#5661F6]">
					توکا
				</span>
				خوش اومدی
			</div>

			<div class="text-center text-xs md:text-sm">
				با اکانت گوگل و یا شماره تلفن همراه می تونی وارد اپلیکیشن شی
			</div>
		</div>

		<NuxtImg
			src="/images/login_image.png"
			width="340"
			format="webp"
			height="340" />

		<div class="grid w-full gap-3 px-4">
			<Btn
				:disabled="props.googleLoading"
				class="relative w-full flex items-center justify-center border border-[#DEE4ED] rounded-md"
				@click="onGoogleLogin">
				<Icon
					:name="props.googleLoading ? 'i-svg-spinners:180-ring-with-bg' : 'i-logos:google-icon'"
					class="absolute end-0 inset-y-0 right-5 z-1 my-a me-a block" />

				<span class="text-center">ورود با اکانت گوگل</span>
			</Btn>

			<div class="my-1 w-full">
				<div class="flex items-center">
					<div class="flex-grow border-t border-[#DEE4ED]" />

					<div class="px-2 text-sm text-[#788BA5]">
						یا
					</div>

					<div class="flex-grow border-t border-[#DEE4ED]" />
				</div>
			</div>

			<Btn
				:disabled="props.googleLoading"
				class="relative w-full flex items-center justify-center border border-[#DEE4ED] rounded-md"
				@click="onPhoneNumber">
				<Icon
					name="i-fa6-solid:phone"
					class="absolute end-0 inset-y-0 right-5 z-1 my-a me-a block bg-[#00A0ED]" />

				<span class="text-center">ورود با تلفن همراه</span>
			</Btn>
		</div>
	</LoginContainer>
</template>
